import { useSession } from '../../../../../contexts/SessionContext'
import { useDirectDebitStatus } from '../../../../../contexts/session/DirectDebitContext'

import HeroCard from '../../../../elements/direct-debit/HeroCard'
import Chip from '../../../../elements/direct-debit/Chip'
import Button from '../../../../elements/direct-debit/Button'
import DDIcon from '../../../../icons/DDIcon'
import styles from './EntryScreen.module.css'

const STEPS = [
  { icon: 'step-verify', title: 'Verify it’s you' },
  { icon: 'step-bank', title: 'Add your bank account' },
  { icon: 'step-send', title: 'Send a one-time transfer' },
]

// Spec screen 01 - explains Direct Debit, the limit, and the steps before any input,
// per design principle #1 ("Explain before asking").
const EntryScreen = () => {
  const { sessionData } = useSession()
  const { showYourDetails, openSheet } = useDirectDebitStatus()
  const merchantName = sessionData?.merchantName || 'this merchant'

  // FLAG: spec calls for a LimitsStrip here ("Up to ₦25,000/per payment · Until Oct 2027")
  // per design principle #2. The first iteration never read a per-payment limit or mandate
  // end date from the backend, and neither field is confirmed to exist on the widget
  // session response - not wiring it up rather than guessing a field name. See final report.

  return (
    <div className={styles.screen}>
      <div className={styles.top}>
        <HeroCard
          title={`Pay ${merchantName} automatically`}
          body={`Set up Direct Debit so ${merchantName} can collect payments from your bank account, up to a limit, until an end date.`}
        />
        <hr className={styles.divider} />
        <Chip icon={<DDIcon name='how-it-works-chip' />}>How it works</Chip>
        <div className={styles.steps}>
          {STEPS.map((step) => (
            <div key={step.icon} className={styles.step}>
              <span className={styles.stepIcon}>
                <DDIcon name={step.icon} />
              </span>
              <span className={styles.stepTitle}>{step.title}</span>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.bottom}>
        <Button onClick={() => showYourDetails()}>Get started</Button>
        <Button variant='link' onClick={() => openSheet('how-it-works')}>
          How does Direct Debit work?
        </Button>
      </div>
    </div>
  )
}

export default EntryScreen
